import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
const NotFound = () => import( '../components/GeneralViews/NotFoundPage.vue')
const UnauthorizedPage = () => import( '../components/GeneralViews/UnauthorizedPage.vue')
// Dashboard pages
// const Overview = () => const(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Overview.vue'))
// const UserOverview = () => const(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/PinnedUser/UserOverview.vue'))


import Overview from 'src/components/Dashboard/Views/Dashboard/Overview.vue'
const UserOverview = () => import( 'src/components/Dashboard/Views/PinnedUser/UserOverview.vue')
const Groups = () => import( 'src/components/Dashboard/Views/Groups/groups.vue')
const Practice = () => import( '@/components/Dashboard/Views/Practice/Practice.vue')
const UserManagement = () => import( '@/components/Dashboard/Views/UserManagement/UserManagement.vue')
const SelectedUserManagement = () => import( '@/components/Dashboard/Views/UserManagement/SelectedUserManagement.vue')
const PlanTemplates = () => import( '@/components/Dashboard/Views/PlanTemplates/planTemplates.vue')
const GroupForm = () => import( 'src/components/Dashboard/Views/Groups/GroupForm.vue')
const ClientReportConfigurationForm = () => import( 'src/components/Dashboard/Views/ClientSummaryReport/ClientSummaryReportForm.vue')
const ClientSummaryReportFormList = () => import( 'src/components/Dashboard/Views/ClientSummaryReport/ClientSummaryReportFormList.vue')
const messageTemplates = () => import( 'src/components/Dashboard/Views/MessageTemplate/messageTemplates')
const AssignLearningModule = () => import( '@/components/Dashboard/Views/LearningModules/AssignLearningModule.vue')
const Reports = () => import( '@/components/Dashboard/Views/Reports/Reports.vue')
const ProgressNotes = () => import( '@/components/Dashboard/Views/ProgressNotes/ProgressNotes.vue')
const StandAloneProgressNote = () => import( '@/components/Dashboard/Views/ProgressNotes/StandAloneProgressNote.vue')
const InboxPage = () => import( '@/components/Dashboard/Views/Inbox/InboxPage.vue')
const PrintSummaryReport = () => import( 'src/components/Dashboard/Views/ClientSummaryReport/ReportConfigurations.vue')
const BadgeConfigurationForm = () => import( 'src/components/Dashboard/Views/Badge/BadgeConfigureForm.vue')
const BadgeConfigureFormList = () => import( 'src/components/Dashboard/Views/Badge/BadgeConfigureFormList.vue')
const AssignBadge = () => import( 'src/components/Dashboard/Views/Badge/AssignBadge.vue')
const PracticeReport = () => import( 'src/components/Dashboard/Views/PracticeSummaryReport/PracticeReport' )
const UserOnBoardingForm = () => import( 'src/components/Dashboard/Views/Onboarding/OnboardingForm.vue')
const UserOnBoardingQRCode = () => import( 'src/components/Dashboard/Views/Onboarding/OnboardingQRCode.vue')
const VariableAuthorizationLayout = () => import( 'src/components/Dashboard/Layout/AuthVariableLayout.vue')
const TestPage = () => import('src/components/Dashboard/Views/Test/TestPage.vue')
const ResourceCenterPage = () => import('src/components/Dashboard/Views/ResourceCenter/ResourceCenterPage.vue')

const ProgressTracker = () => import('src/components/Dashboard/Views/ProgressTracker/ProgressTracker.vue')

import store from "src/store";



const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/practicedashboard',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'practicedashboard',
        name: 'Practice Dashboard',
        component: Overview,
        meta: {
          draggableGridStoreModule: 'practiceDashboardTileLayout'
        }
      },
      {
        path: 'practice',
        name: 'Practice',
        component: Practice
      },
      {
        path: 'UserManagement',
        name: 'User Management',
        component: UserManagement
      },
      {
        path: 'groups',
        component: Groups,
        name: 'Groups',
        children: [
          { path: '', component: GroupForm },
          { path: ':id', component: GroupForm, props: true },
          { path: ':id/edit', component: GroupForm }
        ]
      },
      {
        path: 'ClientReport',
        component: ClientSummaryReportFormList,
        name: 'Create Client Report',
        children: [
          { path: '', component: ClientReportConfigurationForm },
          { path: ':id', component: ClientReportConfigurationForm, props: true },
          { path: ':id/edit', component: ClientReportConfigurationForm }
        ]
      },
      {
        path: 'PracticeReport',
        component: PracticeReport,
        name: 'Practice Report'
      },
      {
        path: 'BuildBadge',
        component: BadgeConfigureFormList,
        name: 'Build Badge',
        children: [
          { path: '', component: BadgeConfigurationForm },
          { path: ':id', component: BadgeConfigurationForm, props: true },
          { path: ':id/edit', component: BadgeConfigurationForm }
        ]
      },
      {
        path: 'Reports',
        name: 'Reports',
        component: Reports
      },
      {
        path: 'Inbox',
        name: 'Inbox',
        component: InboxPage
      }
      ,
      {
        path: 'ProgressTracker',
        name: 'Progress Tracker',
        component: ProgressTracker,
        meta: { requiresRole: true }
      }    
    ]
  },
  {
    path: '/selecteduser',
    component: DashboardLayout,
    redirect: '/selecteduser/userdashboard',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'userdashboard',
        name: 'User Dashboard',
        component: UserOverview,
        meta: {
          draggableGridStoreModule: 'userDashboardTileLayout'
        }
      },
      {
        path: 'selectedusermanagement',
        name: 'Selected User Management',
        component: SelectedUserManagement
      },
      {
        path: 'eatingplan',
        name: 'Eating Plan Templates',
        component: PlanTemplates
      },
      {
        path: 'messagingplan',
        name: 'Messaging Plan Templates',
        component: messageTemplates,
      },
      {
        path: 'learningmodule',
        name: 'Learning Modules',
        component: AssignLearningModule
      },
      {
        path: 'progressNotes',
        name: 'Progress Notes',
        component: ProgressNotes
      },
      {
        path: 'printSummaryReport',
        name: 'Print Summary Report',
        component: PrintSummaryReport
      },
      {
        path: 'assignbadge',
        name: 'Assign Badge',
        component: AssignBadge
      }
     
    ]
  },
  {
    path: '/standAloneProgressNote',
    name: 'Stand Alone ProgressNote',
    component: StandAloneProgressNote,
    meta: {
      requiresAuth: true
    },
  },
  { path: '*', component: NotFound },
  { path: '/UnauthorizedPage', component: UnauthorizedPage},
  
  {
    path: '/appointmentPlus',
    beforeEnter() { location.href = 'https://' + window.location.hostname + '/portal/main/ApptPlus_login.asp?login=' + store.getters["currentUser/getCurrentUsersLogin"] }
  },
  {
    path: '/authvar',
    name: 'Variable Auth Layout',
    component: VariableAuthorizationLayout,
    meta: {
      requiresAuth: false
    },
    children: [
      {
        path: '/onboard',
        name: 'User Onboarding',
        component: UserOnBoardingForm
      },
      {
        path: '/onboardQR',
        name: 'User Onboarding QR Code',
        component: UserOnBoardingQRCode
      }
    ]
  },
  
  {
  path: '/resourcecenter',
  name: 'Public Resource Center',
  component: ResourceCenterPage,
  meta: {
      requiresAuth: false,
      title: 'Resource Center' 
    }
}


];

export default routes
